const warehouseCards = [
  {
    img: require("@/assets/img/icons/palete.svg"),
    stat: "100.000 m²",
    name: "zaprtih skladiščnih kapacitet",
  },
  {
    img: require("@/assets/img/icons/area.svg"),
    stat: "10.000 m²",
    name: "skladiščnih kapacitet s temperaturnim režimom",
  },
  {
    img: require("@/assets/img/icons/forklift.svg"),
    stat: "7.000",
    name: "komisioniranih, prepeljanih palet dnevno",
  },
  {
    img: require("@/assets/img/icons/endcustomers.svg"),
    stat: "1.200",
    name: "dostav končnim strankam dnevno",
  },
  {
    img: require("@/assets/img/icons/vehicles.svg"),
    stat: "300",
    name: "naloženih tovornih vozil dnevno",
  },
  {
    img: require("@/assets/img/icons/officespace.svg"),
    stat: "4.200 m²",
    name: "pisarniških prostorov",
  },
];

export default warehouseCards;
